function nullMap(xs: Array<string>): Record<string, string> {
	const res = {};
	xs.forEach(e => {
		res[e] = null;
	});
	return res;
}

export function rememberKeysBy(
	f: (arg0: Record<string, string>) => any,
	extractor: (arg0: Record<string, string>) => string,
): (arg0: Record<string, string>) => any {
	const pastKeys = {};
	return y => {
		const newKeys = Object.keys(y);
		const key = extractor(y);

		if (typeof key === "string") {
			const pastKeysForEvent = pastKeys[key] || [];
			pastKeys[key] = newKeys;
			return f({ ...nullMap(pastKeysForEvent), ...y });
		} else {
			return f(y);
		}
	};
}
